import { lazy } from 'react'
import { Route, Routes } from 'react-router-dom'
import AuthGate from './components/AuthGate'
import Layout from './components/Layout'

const DashboardPage = lazy(() => import('./pages/DashboardPage'))
const StrategiesPage = lazy(() => import('./pages/StrategiesPage'))
const StrategyPage = lazy(() => import('./pages/StrategyPage'))
const ResearchPage = lazy(() => import('./pages/ResearchPage'))
const ResearchCampaignPage = lazy(() => import('./pages/ResearchCampaignPage'))
const BacktestPage = lazy(() => import('./pages/BacktestPage'))
const ComparePage = lazy(() => import('./pages/ComparePage'))
const ExperimentsPage = lazy(() => import('./pages/ExperimentsPage'))
const PaperOperationsPage = lazy(() => import('./pages/PaperOperationsPage'))
const PaperHistoryPage = lazy(() => import('./pages/PaperHistoryPage'))
const RealReadinessPage = lazy(() => import('./pages/RealReadinessPage'))
const RealOperationsPage = lazy(() => import('./pages/RealOperationsPage'))
const ShadowOperationsPage = lazy(() => import('./pages/ShadowOperationsPage'))
const SignalPage = lazy(() => import('./pages/SignalPage'))
const DataPage = lazy(() => import('./pages/DataPage'))
const SettingsPage = lazy(() => import('./pages/SettingsPage'))
const MarketsPage = lazy(() => import('./pages/MarketsPage'))
const RegimePage = lazy(() => import('./pages/RegimePage'))
const CorrelationsPage = lazy(() => import('./pages/CorrelationsPage'))
const EquityLabPage = lazy(() => import('./pages/EquityLabPage'))
const CalendarPage = lazy(() => import('./pages/CalendarPage'))
const NotFoundPage = lazy(() => import('./pages/NotFoundPage'))

export default function App() {
  return (
    <AuthGate>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/strategies" element={<StrategiesPage />} />
          <Route path="/markets" element={<MarketsPage />} />
          <Route path="/correlations" element={<CorrelationsPage />} />
          <Route path="/equity-lab" element={<EquityLabPage />} />
          <Route path="/regime" element={<RegimePage />} />
          <Route path="/calendar" element={<CalendarPage />} />
          <Route path="/strategies/:strategyId" element={<StrategyPage />} />
          <Route path="/research" element={<ResearchPage />} />
          <Route path="/research/campaign/:campaignId" element={<ResearchCampaignPage />} />
          <Route path="/backtest" element={<BacktestPage />} />
          <Route path="/compare" element={<ComparePage />} />
          <Route path="/experiments" element={<ExperimentsPage />} />
          <Route path="/operations" element={<PaperOperationsPage />} />
          <Route path="/operations/history" element={<PaperHistoryPage />} />
          <Route path="/operations/real-readiness" element={<RealReadinessPage />} />
          <Route path="/operations/real" element={<RealOperationsPage />} />
          <Route path="/operations/shadow" element={<ShadowOperationsPage />} />
          <Route path="/signal" element={<SignalPage />} />
          <Route path="/data" element={<DataPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </AuthGate>
  )
}
